export default __webpack_public_path__ + "static/media/icon-important.388ce84b.svg";